import {
  hasHomedayMaximumPrice,
  shouldShowEntryPopup,
  shouldShowSubmitPopup,
  getOptimalPriceForComparison,
  buildAcknowledgmentUpdate,
  POPUP_TYPES,
} from '@/services/homedayMaximumPrice';
import { acknowledgeHomedayMaximumPricePopup } from '@/services/apiMapper';
import { sendEvent, EVENTS } from '@/services/gtm';
import { MUTATION } from '@/store/CONSTANTS';

export { POPUP_TYPES };

export const homedayMaximumPriceEntryPopupMixin = {
  data() {
    return {
      showHomedayMaximumPricePopup: false,
      isAcknowledgingEntryPopup: false,
    };
  },
  computed: {
    currentDeal() {
      return this.$store.state.wizard.currentDeal;
    },
  },
  mounted() {
    this.maybeShowEntryPopup();
  },
  methods: {
    async onEntryPopupAcknowledge() {
      if (this.isAcknowledgingEntryPopup) {
        return;
      }

      this.isAcknowledgingEntryPopup = true;

      try {
        await this.acknowledgeHomedayMaximumPricePopup(POPUP_TYPES.ENTRY);
      } finally {
        this.showHomedayMaximumPricePopup = false;
        this.isAcknowledgingEntryPopup = false;
      }
    },
  },
};

export default {
  methods: {
    maybeShowEntryPopup() {
      if (!shouldShowEntryPopup(this.currentDeal)) {
        return;
      }

      this.showHomedayMaximumPricePopup = true;
    },
    async acknowledgeHomedayMaximumPricePopup(popupType) {
      const { currentDeal } = this.$store.state.wizard;

      try {
        await acknowledgeHomedayMaximumPricePopup({
          dealUid: currentDeal.uid,
          popupType,
        });
      } catch {
        return false;
      }

      const acknowledgmentUpdate = buildAcknowledgmentUpdate(currentDeal, popupType);

      // Popup visibility is decided from `wizard/currentDeal`, which is not patched by
      // `updateDealProperties` (it only updates the deals list copy). Apply the ack to the
      // current deal module state first so the popups don't reappear when a slide is remounted
      // or the form is resubmitted, and so the `unsavedDeals` snapshot persisted by the commit
      // below already contains the acknowledgment.
      this.$store.commit(MUTATION.WIZARD.CURRENT_DEAL.SET, {
        ...currentDeal,
        ...acknowledgmentUpdate,
      });

      this.$store.commit(MUTATION.WIZARD.UPDATE_DEAL_PROPERTIES, {
        uid: currentDeal.uid,
        properties: acknowledgmentUpdate,
      });

      sendEvent({
        ...EVENTS.HOMEDAY_MAXIMUM_PRICE_POPUP_ACKNOWLEDGED,
        label: popupType,
        value: currentDeal.homedayMaximumPrice,
      });

      return true;
    },
    getSubmitPopupOptimalPrice() {
      return getOptimalPriceForComparison(this.$store);
    },
    shouldShowSubmitHomedayMaximumPricePopup() {
      return shouldShowSubmitPopup(this.currentDeal, this.getSubmitPopupOptimalPrice());
    },
    hasHomedayMaximumPriceForDeal(deal = this.currentDeal) {
      return hasHomedayMaximumPrice(deal);
    },
  },
};
